// extracted by mini-css-extract-plugin
module.exports = {"globalSpinner":"app_globalSpinner__2n3ml","spinner":"app_spinner__1COyX","globalError":"app_globalError___JKrK"};